import { useEffect } from "react";

/**
 * Lightweight client-side SEO hook.
 * Updates document.title, meta description, OG/Twitter tags and canonical URL.
 * For full SSR-friendly SEO, consider migrating to react-helmet-async later.
 */
export default function useSEO({ title, description, canonical, image } = {}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, content) => {
      if (!content) return;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [attr, val] = selector
          .replace(/[[\]"]/g, "")
          .split("=");
        el.setAttribute(attr.replace("meta", "").trim() || "name", val);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', title);
      setMeta('meta[name="twitter:title"]', title);
    }
    if (image) {
      setMeta('meta[property="og:image"]', image);
      setMeta('meta[name="twitter:image"]', image);
    }
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical, image]);
}
